/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Fragment, ReactNode, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Menu,
    Transition,
} from "@headlessui/react";

import { DeleteConsultant } from "../../api/Consultation/DeleteConsultant";

import DeleteModal from "../Shared/DeleteModal";
import { toast } from 'react-toastify';
import { CalendarCheck, Pencil, TrashIcon } from 'lucide-react';

const ConsultantDropdown = ({ children, consultantId }: { children?: ReactNode, consultantId: string; }) => {
    const [isOpen, setIsOpen] = useState(false);


    const handleDelete = async (id: string) => {
        await DeleteConsultant(id);
        toast.success("Consultant deleted successfully");
    };



    return (
        <div className="relative ">
            <DeleteModal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                mutationFn={handleDelete}
                itemId={consultantId}
                queryKey="consultants"
            />

            <Menu as="div" className="relative inline-block">
                <div>
                    <Menu.Button className="inline-flex w-full justify-center  focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75">
                        {children}
                    </Menu.Button>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className="absolute md:-top-32 md:right-0 right-5 mt-2 w-[200px] origin-bottom-right divide-y divide-gray-100 rounded-[7px] border-slate bg-white border border-opacity-20  backdrop-blur-[7.5px] bg-hayak_gray bg-opacity-80 text-left shadow-lg ring-1  -top-4 py-4 px-3 ring-black/5 focus:outline-none z-50 text-primary font-medium text-sm">
                        <div className=' flex flex-col gap-3'>
                            <Menu.Item>
                                <Link to={`/dashboard/consultants/reservations/${consultantId}`} className="flex gap-2 items-center hover:text-secondary transition-all duration-300"><CalendarCheck size={16} /> Reserved Consultants</Link>
                            </Menu.Item>
                            <Menu.Item>
                                <Link to={`/dashboard/consultants/edit-consultant/${consultantId}`} className="flex gap-2 items-center hover:text-secondary transition-all duration-300"><Pencil size={16} /> Edit Consultant</Link>
                            </Menu.Item>
                            <Menu.Item>
                                <button onClick={() => setIsOpen(true)} className="flex gap-2 items-center text-red-500"><TrashIcon size={16} /> Delete Consultant</button>
                            </Menu.Item>

                        </div>
                    </Menu.Items>
                </Transition>
            </Menu>

        </div>
    )
}

export default ConsultantDropdown

